<template>
  <div class="is-pulled-right paragraph-s paragraph-dark-gray">{{ formattedSalary }}</div>
</template>

<script>

import currenciesService from 'top20common/distribution/services/currencies';
import {mapGetters} from 'vuex';

export default {
  props: {
    salary: Number
  },
  computed: {
    ...mapGetters(['userDetailsState']),
    currency() {
      return this.userDetailsState.currency;
    },
    formattedSalary() {
      return this.salary
        ? currenciesService.getSimplifiedFormattedSalary(this.salary, this.currency)
        : `${currenciesService.getSimplifiedDisplayCurrency(this.currency)} ${this.$gettext('unknown')}`;
    }
  }
};
</script>
